class ConfirmAppointmentMapper {
  toPersistence(domainData) {
    return {
      idAtendimento: domainData?.id,
      justificativaConfirmacaoConsulta: domainData?.justification,
      consultaConfirmada: domainData?.confirmedAppointment,
      statusAtendimento: domainData?.appointmentStatus,
    }
  }
}

export default new ConfirmAppointmentMapper()
